// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupHeader {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
}

/* Popup sizing & wrapping */
.mapPopup {
    width: auto;
    white-space: normal;
}

/* Ensure Leaflet popup allows expansion/wrapping */
.leaflet-popup-content {
    white-space: normal !important;
    overflow-wrap: break-word;
    word-break: break-word;
    min-width: 400px;
    max-width: 640px;
}
.leaflet-popup-content * {
    white-space: normal !important;
    overflow-wrap: break-word;
    word-break: break-word;
}

.leaflet-popup-content-wrapper {
    width: auto !important;
    max-width: 100% !important;
}

/* Row layout inside popup: fixed label column + flexible value column */
.mapPopup .row {
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 0.35rem;
}

/* Label column: fixed width, wraps label text if needed */
.mapPopup .row > .col-5,
.mapPopup .row > .label {
    flex: 0 0 140px;
    min-width: 100px;
    max-width: 140px;
    padding-right: 0;
}
/* Value column: flexible, takes remaining space and wraps nicely */
.mapPopup .row > .col-7,
.mapPopup .row > .value {
    flex: 1 1;
    min-width: 120px;
    word-break: break-word;
    overflow-wrap: anywhere;
}

/* Make links wrap and remain clickable */
.mapPopup a {
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    color: var(--bs-link-color);
    text-decoration: underline;
}

/* Social links: expand columns in the social-row and align icon + text */
.mapPopup .social-row > .col-5 {
    flex: 1 1; /* allow social columns to grow so text can sit next to icon */
    min-width: 120px;
}

.mapPopup .social-link {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    white-space: normal;
    max-width: 100%;
    overflow-wrap: anywhere;
    padding: 0px 5px;
}

/* Ensure bootstrap-icons sizing / spacing here if present */
.mapPopup .social-link .bi {
    font-size: 14px;
    line-height: 1;
    display: inline-block;
}

/* Make links wrap nicely when they must */
.mapPopup .hours-value {
    white-space: pre-wrap !important;
    overflow-wrap: break-word;
    word-break: break-word;
}

/* Responsive: reduce label width on very small screens */
@media (max-width: 550px) {
    .mapPopup {
        min-width: 260px;
    }
    .mapPopup .row > .col-5 {
        flex-basis: 110px;
        max-width: 110px;
    }
    .mapPopup .social-row > .col-5 {
        min-width: 100px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/css/MapPopup.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA,wEAAwE;AACxE;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA,0DAA0D;AAC1D;;IAEI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA,mEAAmE;AACnE;;IAEI,SAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,yCAAyC;AACzC;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA,yEAAyE;AACzE;IACI,SAAW,EAAE,8DAA8D;IAC3E,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,4DAA4D;AAC5D;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA,0CAA0C;AAC1C;IACI,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,yDAAyD;AACzD;IACI;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".popupHeader {\n    font-size: 1.25rem;\n    margin-bottom: 0.5rem;\n}\n\n/* Popup sizing & wrapping */\n.mapPopup {\n    width: auto;\n    white-space: normal;\n}\n\n/* Ensure Leaflet popup allows expansion/wrapping */\n.leaflet-popup-content {\n    white-space: normal !important;\n    overflow-wrap: break-word;\n    word-break: break-word;\n    min-width: 400px;\n    max-width: 640px;\n}\n.leaflet-popup-content * {\n    white-space: normal !important;\n    overflow-wrap: break-word;\n    word-break: break-word;\n}\n\n.leaflet-popup-content-wrapper {\n    width: auto !important;\n    max-width: 100% !important;\n}\n\n/* Row layout inside popup: fixed label column + flexible value column */\n.mapPopup .row {\n    display: flex;\n    gap: 0.5rem;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    margin-bottom: 0.35rem;\n}\n\n/* Label column: fixed width, wraps label text if needed */\n.mapPopup .row > .col-5,\n.mapPopup .row > .label {\n    flex: 0 0 140px;\n    min-width: 100px;\n    max-width: 140px;\n    padding-right: 0;\n}\n/* Value column: flexible, takes remaining space and wraps nicely */\n.mapPopup .row > .col-7,\n.mapPopup .row > .value {\n    flex: 1 1 0;\n    min-width: 120px;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n}\n\n/* Make links wrap and remain clickable */\n.mapPopup a {\n    word-break: break-word;\n    overflow-wrap: anywhere;\n    white-space: normal;\n    color: var(--bs-link-color);\n    text-decoration: underline;\n}\n\n/* Social links: expand columns in the social-row and align icon + text */\n.mapPopup .social-row > .col-5 {\n    flex: 1 1 0; /* allow social columns to grow so text can sit next to icon */\n    min-width: 120px;\n}\n\n.mapPopup .social-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.2rem;\n    white-space: normal;\n    max-width: 100%;\n    overflow-wrap: anywhere;\n    padding: 0px 5px;\n}\n\n/* Ensure bootstrap-icons sizing / spacing here if present */\n.mapPopup .social-link .bi {\n    font-size: 14px;\n    line-height: 1;\n    display: inline-block;\n}\n\n/* Make links wrap nicely when they must */\n.mapPopup .hours-value {\n    white-space: pre-wrap !important;\n    overflow-wrap: break-word;\n    word-break: break-word;\n}\n\n/* Responsive: reduce label width on very small screens */\n@media (max-width: 550px) {\n    .mapPopup {\n        min-width: 260px;\n    }\n    .mapPopup .row > .col-5 {\n        flex-basis: 110px;\n        max-width: 110px;\n    }\n    .mapPopup .social-row > .col-5 {\n        min-width: 100px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
